import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query deadlineViolationReasons($where: DeadlineViolationReasonWhereInput) {\n    deadlineViolationReasons(\n      where: $where\n      orderBy: name_asc\n      limit: 100\n      offset: 0\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query deadlineViolationReasons($where: DeadlineViolationReasonWhereInput) {\n    deadlineViolationReasons(\n      where: $where\n      orderBy: name_asc\n      limit: 100\n      offset: 0\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcDeadlineViolationReasonInputComponent = /** @class */ (function () {
    function FcDeadlineViolationReasonInputComponent(apollo, fuseTranslationLoaderService) {
        this.apollo = apollo;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.deadlineContractId = null;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcDeadlineViolationReasonInputComponent.prototype.search = function (searchTerm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: {
                                nameContains: searchTerm,
                                deadlineContractIds: this.deadlineContractId ? [this.deadlineContractId] : null,
                                archived: false
                            }
                        }
                    })
                        .toPromise()
                        .then(function (result) {
                        var items = result.data['deadlineViolationReasons'].items;
                        return items;
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcDeadlineViolationReasonInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcDeadlineViolationReasonInputComponent;
}());
export { FcDeadlineViolationReasonInputComponent };
var templateObject_1;
